import moment from "moment";
import { MSTrend } from "./trend.js";
import { Comtrade } from "./comtrade/comtrade.js";
import i18next from "i18next";


export class MSTrendCSV extends MSTrend {
    constructor(){
        super();
        this.initComtrade()
    }

    addDataSource() {

    }

    ClearOptions(){
        this.clear();
        this.archivestart = 0
        this.archiveendcsv = null
        this.archiveend = +(new Date())
        this.echarts.setOption(
            {
                xAxis: {
                    max: this.archiveend,
                    min: this.archivestart,
                },
            },
            false,
            true
        )
    }

    importCsv(){
        const fileInput = document.createElement('input');
        fileInput.type = 'file';
        fileInput.accept = '.csv';
        fileInput.style.display = 'none';

        fileInput.addEventListener('change', (event) => {
          const file = event.target.files[0];
          if (!file) {
            return;
          }

        if (!file.name.toLowerCase().endsWith('.csv')) {
            $ns.add({
                type: "warning",
                time: new Date().toLocaleString(),
                title: i18next.t('trend_warning'),
                text: i18next.t('trendcsv_import_file_not_svg'),
            });
            return;
        }

          const reader = new FileReader();

          reader.onload = (e) => {
            const text = e.target.result;
            const data = this.parseCSV(text);
            if(!data || !data.pens){
                $ns.add({
                    type: "warning",
                    time: new Date().toLocaleString(),
                    title: i18next.t('trend_warning'),
                    text: i18next.t('trendcsv_import_file_broken'),
                });
            } else {
                this.setData(data)
            }
          };

          reader.readAsText(file);
        });

        fileInput.click();
    }

    async parseComtrade(group, format){
        try {
            const cfgText = await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (e) => resolve(e.target.result);
                reader.onerror = reject;
                reader.readAsText(group.cfg);
            });

            const datBuffer = await new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (e) => resolve(e.target.result);
                reader.onerror = reject;
                reader.readAsArrayBuffer(group.dat);
            });

            const lines = cfgText.split('\n').map(line => line.trim()).filter(line => line.length > 0);
            let lineIndex = 1;

            const channelLine = lines[lineIndex].split(',');
            const analogChannels = parseInt(channelLine[1].replace(/\D/g, ''));
            const digitalChannels = channelLine[2] ? parseInt(channelLine[2].replace(/\D/g, '')) : 0;
            lineIndex++;

            const analogChannelInfo = [];
            for (let i = 0; i < analogChannels; i++) {
                const parts = lines[lineIndex].split(',');
                analogChannelInfo.push({
                    index: parseInt(parts[0]),
                    name: parts[1],
                    phase: parts[2],
                    ccbm: parts[3],
                    uu: parts[4],
                    a: parseFloat(parts[5]),
                    b: parseFloat(parts[6]),
                    skew: parseFloat(parts[7]),
                    min: parseFloat(parts[8]),
                    max: parseFloat(parts[9]),
                    primary: parseFloat(parts[10]),
                    secondary: parseFloat(parts[11]),
                    PS: parts[12]
                });
                lineIndex++;
            }

            lineIndex += digitalChannels + 1;

            const nrates = parseInt(lines[lineIndex]);
            lineIndex++;

            const sampleRates = [];
            for (let i = 0; i < nrates; i++) {
                const [samp, endsamp] = lines[lineIndex].split(',').map(s => parseFloat(s));
                sampleRates.push({ samp, endsamp });
                lineIndex++;
            }

            const startDateTime = lines[lineIndex].replaceAll("/", "-");
            lineIndex += 2;

            const fileType = lines[lineIndex].toUpperCase().trim();
            lineIndex++;

            let startTimestamp;
            const finalFormat =  format.replaceAll("/", "-")
            const date = moment(startDateTime, finalFormat);
            startTimestamp = date.valueOf()

            const pens = [];
            let min = Infinity;
            let max = -Infinity;

            if (fileType === 'BINARY') {
                const dataView = new DataView(datBuffer);
                let offset = 0;
                const bytesPerSample = 4 + analogChannels * 2 + Math.ceil(digitalChannels / 16) * 2;
                const totalSamples = Math.floor(datBuffer.byteLength / bytesPerSample);

                for (let ch = 0; ch < analogChannels; ch++) {
                    const channelData = [];
                    offset = 0;

                    for (let i = 0; i < totalSamples; i++) {
                        const sampleNumber = dataView.getUint32(offset, true);
                        offset += 4;

                        const rawValue = dataView.getInt16(offset + ch * 2, true);
                        const info = analogChannelInfo[ch];
                        const realValue = rawValue * info.a + info.b;

                        const sampleRate = sampleRates[0].samp;
                        const sampleTimeMs = (sampleNumber / sampleRate) * 1000;
                        const timestamp = startTimestamp + sampleTimeMs;

                        channelData.push([timestamp, realValue, 0]);

                        if (timestamp < min) min = timestamp;
                        if (timestamp > max) max = timestamp;

                        offset = (i + 1) * bytesPerSample;
                    }

                    channelData.sort((a, b) => a[0] - b[0]);

                    pens.push({
                        name: analogChannelInfo[ch].name,
                        data: channelData
                    });
                }
            } else {
                const datText = new TextDecoder().decode(datBuffer);
                const datLines = datText.split('\n').filter(line => line.trim());

                for (let ch = 0; ch < analogChannels; ch++) {
                    pens.push({
                        name: analogChannelInfo[ch].name,
                        data: []
                    });
                }

                datLines.forEach((line, idx) => {
                    const values = line.split(',').map(s => s.trim());
                    const sampleNumber = parseInt(values[0]);

                    for (let ch = 0; ch < analogChannels; ch++) {
                        const rawValue = parseInt(values[2 + ch]);
                        const info = analogChannelInfo[ch];
                        const realValue = rawValue * info.a + info.b;

                        const sampleRate = sampleRates[0].samp;
                        const sampleTimeMs = (sampleNumber / sampleRate) * 1000;
                        const timestamp = startTimestamp + sampleTimeMs;

                        pens[ch].data.push([timestamp, realValue, 0]);

                        if (timestamp < min) min = timestamp;
                        if (timestamp > max) max = timestamp;
                    }
                });

                pens.forEach(pen => {
                    pen.data.sort((a, b) => a[0] - b[0]);
                });
            }

            const result = {
                min: min,
                max: max,
                pens: pens
            };

            if(max === -Infinity || min === Infinity){
                $ns.add({
                    type: "warning",
                    time: new Date().toLocaleString(),
                    title: i18next.t('trend_warning'),
                    text: i18next.t('trend_comtrade_parsing_error'),
                });
            } else {
                this.setData(result)

                return result;
            }

        } catch (error) {
            $ns.add({
                type: "warning",
                time: new Date().toLocaleString(),
                title: i18next.t('trend_warning'),
                text: i18next.t('trend_comtrade_parsing_error'),
            });
        }
    }

    saveState(){

    }

    initTrendKits(){

    }

    parseCSV(text) {
        try{
            const lines = text.split(/\r?\n/).filter(line => line.trim() !== ''); // строки
            const headers = lines[0].split(',').map(h => h.trim()); // заголовки
            if(headers[0] !== "Timestamp"){
                return
            }

            const pensData = {}

            headers.forEach((el, i) => {
                    if(el !== "Timestamp"){
                        pensData[el] = {
                            data: [],
                            name: el
                        }
                    }
            })

            const rows = lines.slice(1)
            let min, max;
            if(rows.length > 2){
                min = this.getTime(+rows[0].split(',')[0])
                max = this.getTime(+rows[1].split(',')[0])
            }

            rows.forEach((line, i) => {
                const values = line.split(',');
                const time = this.getTime(+values[0])
                if(i > 1){
                    if(min > time) min = time
                    if(max < time) max = time
                }
                values.forEach((val, i) => {
                        if(val){
                            if(i !== 0 && val !== "-" && val !== ""){
                                pensData[headers[i]].data.push([time, +val, 0])
                            }
                        }
                })
            })
            return {pens: Object.values(pensData), max, min}
        } catch(e){
            return
        }
    }

    getTime(filetime){
        const difference = 116444736000000000n;
        const ft = BigInt(filetime)
        return Number((ft - difference) / 10000n);
    }

    get archiveend() {
        return this.archiveendcsv ?? this._archiveend;
    }
    set archiveend(value) {
        if(this.archiveendcsv && this.archiveendcsv !== value){
            return
        }
        const oldVal = this._archiveend
        this._archiveend = +value;
        if(oldVal === 0){
            this.initIntervalState();
        }
        this.msdatazoom.max = value
        if (!this.autoscroll && oldVal !== 0) return
        if(this.initedStatedZoom) {
            this.initedStatedZoom = false
            return
        }
        this.SetParameter("till", this.archiveend, true);
    }

    setData(data){
        this.clear();
        const pensWithSource = data.pens.map(({name}) => ({
            id: `${name}source`,
            title: name,
        }))
        this.reCreatePens(
            pensWithSource,
            true
        );
        data.pens.forEach((data, i) => {
            this.pens.series[i * 2].data = data.data;
            this.pens.series[i * 2 + 1].data = []; //опустошить массив
            if(data.data[data.data.length - 1]?.[1]){
                this.legend.setLastValue(
                    i,
                    data.data[data.data.length - 1][1],
                    this.pens[i].yformat,
                    this.pens[i].unit,
                    this.pens[i].logscale
                );
            this.pens[i].lastValue = data.data[data.data.length - 1]
            }
        })
        this.legend.render();
        if(data.min && data.max){
            const startTime = data.min
            const endTime = data.max
            this.archivestart = startTime
            this.archiveendcsv = endTime
            this.archiveend = endTime
            this.updateSliderZoom(startTime, endTime)
            this.updateInterval(endTime - startTime)
        }
        this.updateOld()
    }

    update(){

    }

    updateOld() {
            if (this.isbusy) return;
            if (!this.isVisibleFromRoot) return;
            let needRedraw = false;
            this.pens.forEach((pen) => {
                if (pen.drawconstant) {
                    let lastElement = pen.serie.data[pen.serie.data.length - 1];
                    if (this.archiveend > this.msdatazoom.minvalue) {
                        const seriedata = pen.serie.data;
                        if (lastElement) {
                            if (lastElement[3]) {
                                const preLastElement = seriedata[pen.serie.data.length - 2];
                                if (preLastElement && preLastElement[3]) {
                                    seriedata.splice(seriedata.length - 2);
                                } else {
                                    seriedata.splice(seriedata.length - 1);
                                }
                                lastElement = seriedata[seriedata.length - 1];
                            }
                            if (lastElement[0] < this.msdatazoom.minvalue) {
                                seriedata.push([
                                    this.msdatazoom.minvalue + 1,
                                    lastElement[1],
                                    lastElement[2],
                                    true,
                                ]);
                            }
                            const tm =
                                this.archiveend > lastElement[0]
                                    ? this.archiveend
                                    : lastElement[0];
                            seriedata.push([
                                tm,
                                lastElement[1],
                                lastElement[2],
                                true,
                            ]);
                            needRedraw = true;
                        }
                    }
                } else if (pen.needRedraw) {
                    pen.needRedraw = false;
                    needRedraw = true;
                }
            });
            for (let i = 0; i < this.pens.series.length; i++) {
                if (i % 2 !== 0 || this.pens.series[i].data[this.pens.series[i].data.length - 1]?.[1] !== null) continue
                const lastTime = this.pens.series[i].data[this.pens.series[i].data.length - 1][0]
                if(this.pens.series[i + 1].data.length){
                    const lastValue = this.pens.series[i + 1]?.data[this.pens.series[i + 1].data.length - 1][1]
                    if (this.pens.series[i + 1].data[this.pens.series[i + 1].data.length - 1][3]) {
                        this.pens.series[i + 1].data[this.pens.series[i + 1].data.length - 1] = [lastTime, lastValue, undefined, true]
                    } else {
                        this.pens.series[i + 1].data.push([lastTime, lastValue, undefined, true])
                    }
                }
            }
            if (
                this.pens.rightBorder !== this.msdatazoom.maxvalue ||
                this.pens.leftBorder !== this.msdatazoom.minvalue
            ) {
                this.pens.rightBorder = this.msdatazoom.maxvalue;
                this.pens.leftBorder = this.msdatazoom.minvalue;
                this.updateInsideZoom(this.pens.leftBorder, this.pens.rightBorder);
                needRedraw = true;
            }
            if (needRedraw) {
                    const startTime = new Date()
                    this.echarts.setOption(
                        {
                            series: this.pens.series,
                            dataZoom: {
                                dataZoomIndex: 0,
                                startValue: this.autoscroll ? this.archiveend - this.interval : this.msdatazoom.minvalue,
                                endValue: this.autoscroll ? this.archiveend : this.msdatazoom.maxvalue,
                            },
                            xAxis: {
                                max: this.archiveend,
                                min: this.archivestart,
                            },
                        },
                        false,
                        true
                    );
                    if(this.isLog){
                        const endTime = new Date();
                        const proccesTime = +endTime - +startTime;
                        if(proccesTime > 100){
                            this.addLog("Установка данных в echart", startTime, endTime, true)
                        }
                    }
                    if(this.tableTime){
                        this.echarts.setOption({
                            series: [
                                {
                                markLine: {
                                    lineStyle: {
                                        type: "solid",
                                        color: "rgba(0, 0, 0, 1)"
                                    },
                                data: [
                                    {
                                        xAxis: this.tableTime,
                                        label: {
                                            formatter: getFormattedValue(this.xformat, new Date(this.tableTime)),
                                            color: '#000000',
                                            fontSize: 12,
                                            backgroundColor: 'rgba(255, 255, 255, 0.7)',
                                            padding: [3, 5, 3, 5],
                                            borderWidth: 0
                                        }
                                    }
                                    ]
                                }
                            }],
                        })
                    }
                this.echarts._zr.animation.update();
            }
        }

    clear(){
        this.reCreatePens(
            [],
            true
        );
    }

    initComtrade(){
        const btn = this.toolbar.shadowRoot.querySelector("#tool-comtrade-btn")
        this.comtrade = new Comtrade(this, btn)
    }

    get autoscroll() {
        return false;
    }

    set autoscroll(value) {

    }
}
